import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3c5b3ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-view__header" }, null, -1))
const _hoisted_2 = {
  key: 0,
  style: {"padding-top":"50px"}
}

import router from "@/router";
import RepositoryFactory from "@/factories/RepositoryFactory";
import {ref} from "vue";
import Work from "@/models/Work";
import CSection from "@/components/section/CSection.vue";
import CSectionSubtitle from "@/components/section/CSectionSubtitle.vue";
import CSectionTitle from "@/components/section/CSectionTitle.vue";
import CSectionText from "@/components/section/CSectionText.vue";
import CSlider from "@/components/CSlider.vue";
import CWorkPreview from "@/components/my-works/CWorkPreview.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailWorkView',
  setup(__props) {

const work = ref<Work|null>(null)
const id = (router.currentRoute.value.params.id || '') as string

RepositoryFactory
    .default()
    .getWorkByName(id)
    .then(data => {
      if (data == null) {
        router.push({ name: 'home' })
      }
      work.value = data
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (work.value)
      ? (_openBlock(), _createElementBlock("main", _hoisted_2, [
          _createElementVNode("article", null, [
            _createVNode(CSection, null, {
              default: _withCtx(() => [
                (work.value.images?.length !== 0)
                  ? (_openBlock(), _createBlock(CSlider, {
                      key: 0,
                      ref: "slider",
                      items: work.value.images || []
                    }, null, 8, ["items"]))
                  : (_openBlock(), _createBlock(CWorkPreview, {
                      key: 1,
                      work: work.value,
                      style: {"height":"350px","border-radius":"20px"}
                    }, null, 8, ["work"])),
                _createVNode(CSectionSubtitle, { style: {"text-align":"left","margin-top":"30px"} }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`portfolio.${work.value.name}.quote`)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(CSectionTitle, { style: {"text-align":"left"} }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`portfolio.${work.value.name}.name`)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(CSectionText, {
                  style: {"text-align":"left","margin-top":"20px"},
                  innerHTML: _ctx.$t(`portfolio.${work.value.name}.description`)
                }, null, 8, ["innerHTML"])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})